import {ModalService} from '../../../../../models/services/modal-service';
import {SharedItemBase} from '../../models/shared-item-base';

export class SharedModalServiceAbstract extends ModalService<SharedItemBase> {}
